// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"610585ec","369":"d886c32d","441":"e1987fa9","453":"082eee73","455":"27955665","534":"405826bb","957":"ce0ed6fb","981":"8cada97f"}[chunkId] + ".chunk.js";
};